import React from "react";
import { PRIORITIES, STATUSES, RISK_LEVELS } from "../lib/constants";

export function PriorityBadge({ priority, className = "" }) {
  const p = PRIORITIES[priority] || PRIORITIES.media;
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide ${className}`}
      style={{ backgroundColor: p.bg, color: p.text, borderColor: p.border }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: p.dot }} />
      {p.label}
    </span>
  );
}

export function StatusBadge({ status }) {
  const s = STATUSES[status] || STATUSES.pendiente;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide ${s.cls}`}
    >
      {s.label}
    </span>
  );
}

export function RiskBadge({ level }) {
  const r = RISK_LEVELS[level] || RISK_LEVELS.bajo;
  return (
    <span className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide ${r.cls}`}>
      {r.label}
    </span>
  );
}

export function ProgressBar({ value, color = "#0A0A0A", height = 6 }) {
  return (
    <div className="w-full bg-slate-100" style={{ height }}>
      <div className="h-full transition-[width] duration-300" style={{ width: `${Math.min(value, 100)}%`, backgroundColor: color }} />
    </div>
  );
}

export function Avatar({ user, size = 28 }) {
  const initials = (user?.name || "?").split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
  if (user?.avatar) {
    return <img src={user.avatar} alt={user.name} className="rounded-full object-cover border border-slate-200" style={{ width: size, height: size }} />;
  }
  return (
    <div className="flex items-center justify-center rounded-full bg-slate-900 text-white font-semibold border border-slate-200"
      style={{ width: size, height: size, fontSize: size * 0.38 }}>
      {initials}
    </div>
  );
}
